import { FI18n } from '@freelog/tools-lib';

export type SubjectTypeItem = 'resource' | 'collection' | 'exhibitCollection';

export interface Option {
  value: string;
  label: string;
  values: string[];
  labels: string[];
  children: Option[];
}

export interface ServerData {
  code: string;
  name: string;
  children: ServerData[];
}

export interface SelectedValue {
  value: string;
  label: string;
  values: string[];
  labels: string[];
}

const SUBJECT_TYPE_MAP: Record<SubjectTypeItem, number> = {
  resource: 1,
  collection: 4,
  exhibitCollection: 5,
};

/** 将 subjectTypeArr 转为 API 所需的 subjectType 参数（支持多值如 '1,4'） */
export function toSubjectTypeParam(
  subjectTypeArr: SubjectTypeItem[],
): string | undefined {
  if (subjectTypeArr.length === 0) return undefined;
  return subjectTypeArr.map((st) => SUBJECT_TYPE_MAP[st]).join(',');
}

/** 构建选项树，并在每层插入「全部」、有 resource 时插入「其他」 */
export function buildOptionTree(
  data: ServerData[],
  parent: Option | null,
  subjectTypeArr: SubjectTypeItem[],
): Option[] {
  const result: Option[] = data.map((d) => {
    const res: Option = {
      value: d.code,
      label: d.name,
      values: [...(parent?.values || []), d.code],
      labels: [...(parent?.labels || []), d.name],
      children: [],
    };
    return {
      ...res,
      children: buildOptionTree(d.children, res, subjectTypeArr),
    };
  });

  if (result.length === 0) return [];

  const allLabel = FI18n.i18nNext.tAuto('filter_resourcetype_option_all');
  const otherLabel = FI18n.i18nNext.tAuto('filter_resourcetype_type_other');

  if (parent) {
    result.unshift({
      value: parent.value + '#all',
      label: allLabel,
      values: [...parent.values, parent.value + '#all'],
      labels: [...parent.labels, allLabel],
      children: [],
    });
    if (subjectTypeArr.includes('resource')) {
      result.push({
        value: parent.value + '#other',
        label: otherLabel,
        values: [...parent.values, parent.value + '#other'],
        labels: [...parent.labels, otherLabel],
        children: [],
      });
    }
  } else {
    result.unshift({
      value: '#all',
      label: allLabel,
      values: ['#all'],
      labels: [allLabel],
      children: [],
    });
  }
  return result;
}
